export default "__VITE_ASSET__BnsD4Fp0__"